// IMPORTS

// external
import algosdk, {
  Algodv2,
  Transaction,
  LogicSigAccount,
  SuggestedParams,
  assignGroupID,
  bytesToBigInt
} from "algosdk"

// global
import { getAccountBalances } from "../../stateUtils"
import { getParams, getPaymentTxn } from "../../transactionUtils"
import AlgofiUser from "../../algofiUser"

// CONSTANTS

const LINEAR_SWAP_LOGIC_SIG = new Uint8Array([6, 32, 5, 1, 0, 4, 240, 214, 134, 15, 203, 148, 146, 222, 1, 35, 56, 0, 128, 32, 77, 24, 114, 157, 193, 118, 18, 150, 182, 193, 27, 233, 232, 217, 123, 152, 46, 141, 228, 36, 93, 37, 113, 111, 45, 242, 225, 182, 55, 176, 180, 25, 18, 65, 0, 2, 34, 67, 50, 4, 129, 2, 18, 129, 17, 16, 68, 49, 22, 34, 18, 129, 18, 16, 68, 49, 1, 35, 18, 129, 20, 16, 68, 49, 16, 36, 18, 129, 22, 16, 68, 49, 32, 50, 3, 18, 129, 23, 16, 68, 49, 21, 50, 3, 18, 129, 24, 16, 68, 49, 22, 34, 9, 56, 16, 36, 18, 129, 26, 16, 68, 49, 22, 34, 9, 56, 20, 49, 0, 18, 129, 27, 16, 68, 49, 22, 34, 9, 56, 18, 49, 18, 18, 129, 29, 16, 68, 49, 17, 37, 18, 49, 22, 34, 9, 56, 17, 33, 4, 18, 16, 49, 17, 33, 4, 18, 49, 22, 34, 9, 56, 17, 37, 18, 16, 17, 129, 31, 16, 68, 34, 67])

const USDC_ASSET_ID = 31566704
const STBL_ASSET_ID = 465865291

// INTERFACE

export default class LinearPool {
  // static
  public algod: Algodv2

  public logicSig: LogicSigAccount

  public usdcBalance: number
  public stblBalace: number
  
  constructor(algod: Algodv2) {
    this.algod = algod
    this.logicSig = new LogicSigAccount(LINEAR_SWAP_LOGIC_SIG)
  }

  async loadState() {
    let balances = await getAccountBalances(this.algod, this.logicSig.address())
    this.usdcBalance = balances[USDC_ASSET_ID]
    this.stblBalace = balances[STBL_ASSET_ID]
  }

  // TRANSACTION GETTERS

  async getSwapTxns(
    user: AlgofiUser,
    inputAssetId: number,
    amount: number
  ): Promise<Transaction[]> {
    const params  = await getParams(this.algod)
    const transactions = []
    
    let outputAssetId = inputAssetId == USDC_ASSET_ID ? STBL_ASSET_ID : USDC_ASSET_ID
    
    params.fee = 2000
    transactions.push(getPaymentTxn(params, user.address, this.logicSig.address(), inputAssetId, amount))
    
    params.fee = 0
    transactions.push(getPaymentTxn(params, this.logicSig.address(), user.address, outputAssetId, amount))

    return assignGroupID(transactions)
  }
}